import { Grid, Link, Typography, useTheme } from "@mui/material";
import { PublicOutlined } from "@mui/icons-material";
import React from "react";

interface Props {
    label: string;
    isDefault: boolean;
    onReset?: () => void;
}

export function SettingsFieldLabel({ label, isDefault, onReset }: Props) {
    const theme = useTheme();

    return (
        <Grid
            container
            alignItems="center"
            columnGap={0.5}
            flexWrap="nowrap"
            sx={{ marginBottom: theme.spacing(0.5) }}
        >
            <Grid item>
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 500,
                        fontSize: "12px",
                        lineHeight: "16px",
                        fontFamily: theme.typography.fontFamily,
                        color: theme.palette.text.secondary,
                    }}
                >
                    {label}
                </Typography>
            </Grid>
            {isDefault && (
                <Grid
                    item
                    container
                    alignItems="center"
                    columnGap={0.25}
                    width="fit-content"
                    flexWrap="nowrap"
                >
                    <PublicOutlined
                        sx={{
                            fontSize: "12px",
                            color: "text.secondary",
                        }}
                    />
                    <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ fontSize: "11px", whiteSpace: "nowrap" }}
                    >
                        Global default
                    </Typography>
                </Grid>
            )}
            {!isDefault && onReset && (
                <Grid item>
                    <Link
                        component="button"
                        variant="caption"
                        onClick={onReset}
                        underline="hover"
                        sx={{ fontSize: "11px", whiteSpace: "nowrap" }}
                    >
                        Reset to default
                    </Link>
                </Grid>
            )}
        </Grid>
    );
}

export const renderSettingsFieldLabel = (props: Props) => (
    <SettingsFieldLabel {...props} />
);
